/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {DateTimeFieldViewer} from "./DateTimeFieldViewer";
import {UserFieldViewer} from "../ServiceDrivenViewers";
import React from "react";

export const UserWithDateTimeFieldViewer = (props) => {
	const {userId, date, emptyMessage = null} = props;
	return <div className="inline-field-viewer">{[
		userId && <UserFieldViewer key={1} Value={userId}/>,
		userId && date && <span key={2}>at</span>,
		date && <DateTimeFieldViewer key={3} Value={date}/>,
		(!userId && !date && emptyMessage) ? <span key={4}>{emptyMessage}</span> : null,
	].filter(Boolean)}
	</div>;
};
